import React from "react";

export default function AdminPageHeader({ icon: Icon, title, subtitle, actions }) {
  return (
    <div className="flex items-start justify-between gap-4 flex-wrap mb-6">
      <div>
        <h1 className="hv-heading text-2xl sm:text-3xl text-hv-navy inline-flex items-center gap-2">
          {Icon && <Icon className="w-6 h-6 text-hv-coral" strokeWidth={2.5} />}
          {title}
        </h1>
        {subtitle && <p className="text-sm text-hv-slate mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}
